
          <div class="cust-width">
            <div class="table-container">
              <table class="table">
                <thead>
                  <tr>
                    <th>S/N</th>
                    <th>TCODE</th>
                    <th>Association</th>
                    <th>Vehicle Type</th>
                    <th>Route</th>
                    <th>Total Payyment Made</th>

                  </tr>
                </thead>
                <tbody *ngIf="data?.length > 0">
                  <tr *ngFor="let eachDetail of data; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{ eachDetail?.tcode | uppercase }}</td>
                    <td>{{ eachDetail?.association | uppercase }}</td>
                    <td>{{ eachDetail?.vehicle_type | uppercase }}</td>

                    <td>{{ eachDetail?.vehicle_route | uppercase }}</td>
                    <td>{{ eachDetail?.totalAmount | nairaCurrency }}</td>

                  </tr>
                </tbody>
              </table>
              <div class="p-3">
                <p class="text-center" *ngIf="!data && !(resultsEmpty || error)">Loading... Please Wait... </p>

                <p class="text-center text-danger" *ngIf="resultsEmpty">No data available</p>
                <p class="text-center text-danger" *ngIf="error">Error fetching data</p>
              </div>
              <div class="d-flex justify-content-between align-items-center mt-3">
                <div class="d-flex align-items-center">
                  <label for="pageSize" class="me-2 fw-semibold">Page Size:</label>
                  <select id="pageSize" class="form-select form-select-sm" style="width: auto" [(ngModel)]="pageSize"
                    (change)="onPageSizeChange()">
                    <option *ngFor="let size of pageSizeOptions" [value]="size">
                      {{ size }}
                    </option>
                  </select>
                </div>

                <ngb-pagination class="my-3" [(page)]="currentPage" [pageSize]="pageSize" [collectionSize]="count"
                  [maxSize]="5" [boundaryLinks]="true" [directionLinks]="true" (pageChange)="fetchInfo()">
                </ngb-pagination>
              </div>
            </div>

          </div>
